module.exports = __webpack_public_path__ + "static/media/36.a85de330.png";